export const LIST_BANNERS = 'LIST_BANNERS'
export const SET_BANNER = 'SET_BANNER'
export const SET_BANNER_SET = 'SET_BANNER_SET'
export const SET_BANNER_SET_EDIT = 'SET_BANNER_SET_EDIT'
export const SET_RESULT_COUNT = 'SET_RESULT_COUNT'
export const SET_FILTER_TOTAL = 'SET_FILTER_TOTAL'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_PREVIEW = 'SET_PREVIEW'
export const SET_SEARCH_QUERY = 'setSearchQuery' // lower case for backwards compat